module.exports = __webpack_public_path__ + "static/img/046 3.48ee5e2b.jpg";